import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DebugModeService {
  private _isDebugMode = false;

  get isDebugMode(): boolean {
    return this._isDebugMode;
  }

  activate(debugParam: string | null): void {
    const allowedEnvs = ['dev', 'local-dev', 'test'];
    if (debugParam === 'true' && allowedEnvs.includes(environment.appEnv)) {
      this._isDebugMode = true;
      console.debug('[DebugMode] Career survey debug mode activated');
    }
  }
}
